export default __webpack_public_path__ + "static/media/MAIN BACK.9c70870f.jpg";